module.exports = __webpack_public_path__ + "static/media/logo.ce5cc4f3.png";